































import { Vue, Component, Watch } from "vue-property-decorator";
import PropertyCard from "@/properties/PropertyCard.vue";
import Filters from "@/properties/Filters.vue";
import { propertiesStore } from "@/properties/store";
import { Property } from "./types";

@Component({
  components: {
    PropertyCard,
    Filters
  }
})
export default class Dashboard extends Vue {
  showFilters = false
  properties: Property[] = [];
  updating = false;
  filters = {
    categorie: [0, 1],
    fPrice: [0, 5000]
  }
  propertyAddressFilter = "";
  posts = this.properties;
  state: "idle" | "busy" | "done" = "idle";

  async created() {
    this.state = 'busy';
    await propertiesStore.loadProperties();
    this.properties = propertiesStore.state.items;
    this.posts = this.properties;
    this.state = 'idle';
  }



  @Watch("filters", { deep: true })
  async updateData() {
    this.showFilters = false
    if (!this.filters) {
      this.posts = this.properties
      return
    }
    console.log("update data", this.filters.fPrice)
    this.updating = true;
    let posts = this.properties;

    const term = this.propertyAddressFilter.toLowerCase();
    // array of functions that take a property and return a boolean
    var conditions: ((p: Property) => boolean)[] = [
      (p) => term === "" || p.address.toLowerCase().includes(term),
      (p) => p.price >= this.filters.fPrice[0] && p.price <= this.filters.fPrice[1],
      (p) => this.filters.categorie.includes(p.type)
    ];

    this.posts = posts.filter((property) => conditions.every(condition => condition(property)));
    this.updating = false;
  }
}
